// // import React, { useEffect, useContext } from 'react';
// // import axios from 'axios';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import { AuthContext } from '../context/AuthContext';


// import React, { useEffect, useContext } from 'react';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';

// function RegisterSuccess() {
//   const { setIsAuthenticated } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const completeRegistration = async () => {
//       const params = new URLSearchParams(location.search);
//       const sessionId = params.get('session_id');

//       if (!sessionId) {
//         console.error('No session ID found');
//         navigate('/register');
//         return;
//       }

//       try {
//         // Verify session and complete registration
//         const response = await axios.post('http://localhost:8000/payment/complete-registration', { sessionId });
//         if (response.data.success) {
//           setIsAuthenticated(true);
//           navigate('/dashboard'); // Redirect to dashboard upon success
//         }
//       } catch (err) {
//         console.error('Error completing registration', err);
//         navigate('/register');
//       }
//     };

//     completeRegistration();
//   }, [location, navigate, setIsAuthenticated]);

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gray-50">
//       <h2 className="text-2xl font-bold text-center">Completing Registration...</h2>
//     </div>
//   );
// }

// export default RegisterSuccess;

// File: /src/components/RegisterSuccess.js
// Description: Improved handling of successful registration after payment, including user state update and redirect.

// import React, { useEffect, useContext, useState } from 'react';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';

// function RegisterSuccess() {
//   const { setIsAuthenticated } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const completeRegistration = async () => {
//       const params = new URLSearchParams(location.search);
//       const sessionId = params.get('session_id');

//       if (!sessionId) {
//         console.error('No session ID found');
//         setError('No session ID found. Redirecting to registration.');
//         setLoading(false);
//         setTimeout(() => navigate('/register'), 3000);
//         return;
//       }

//       try {
//         // Verify session and complete registration
//         const response = await axios.post('http://localhost:8000/payment/complete-registration', { sessionId });
//         if (response.data.success) {
//           setIsAuthenticated(true);
//           navigate('/dashboard'); // Redirect to dashboard upon success
//         } else {
//           setError(response.data.message || 'Registration could not be completed. Redirecting to registration.');
//           setLoading(false);
//           setTimeout(() => navigate('/register'), 3000);
//         }
//       } catch (err) {
//         console.error('Error completing registration:', err);
//         setError('Error completing registration. Redirecting to registration.');
//         setLoading(false);
//         setTimeout(() => navigate('/register'), 3000);
//       }
//     };

//     completeRegistration();
//   }, [location, navigate, setIsAuthenticated]);

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gray-50">
//       {loading ? (
//         <h2 className="text-2xl font-bold text-center">Completing Registration...</h2>
//       ) : (
//         <h2 className="text-2xl font-bold text-center text-red-500">{error}</h2>
//       )}
//     </div>
//   );
// }

// export default RegisterSuccess;

import React, { useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function RegisterSuccess() {
  const { setIsAuthenticated, setHasPaid } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const completeRegistration = async () => {
      const params = new URLSearchParams(location.search);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/register');
        return;
      }

      try {
        // Verify session and complete registration
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payment/complete-registration`, { sessionId });

        if (response.data.success) {

            // Fire Google Ads conversion tracking
            if (window.gtag) {
              window.gtag('event', 'conversion', {
                'send_to': 'AW-16853915592/i5UfCIf6pKgaEMivyeQ-',
                'transaction_id': sessionId
              });
            }
            
          setIsAuthenticated(true);
          setHasPaid(true); // Set payment flag to true after successful payment
          navigate('/dashboard');
        } else {
          navigate('/register');
        }
      } catch (err) {
        console.error('Error completing registration:', err);
        navigate('/register');
      }
    };

    completeRegistration();
  }, [location, navigate, setIsAuthenticated, setHasPaid]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <h2 className="text-2xl font-bold text-center">Completing Registration...</h2>
    </div>
  );
}

export default RegisterSuccess;
